// React context for the active-call SSE client (R10).
//
// Each of the six R9 write-heavy review screens pulls the active-call
// signal from this context, feeds the current customerId into the hook
// as a filter, and merges the result into its own `companionSignals`
// before resolving the DataBoundary state.
//
// The provider lives at app bootstrap. Tests mount the screens either
// without the provider (null client -> hook stays idle) or with a test
// provider that injects a fake client.

import {
  createContext,
  useContext,
  type ReactNode,
} from 'react';
import type { ActiveCallStreamClient } from '../api/active-call-stream.js';

export interface ActiveCallContextValue {
  client: ActiveCallStreamClient | null;
  projectId: string | null;
  repId: string | null;
}

const ActiveCallContext = createContext<ActiveCallContextValue>({
  client: null,
  projectId: null,
  repId: null,
});

export function ActiveCallProvider(
  { value, children }: { value: ActiveCallContextValue; children: ReactNode },
): ReactNode {
  return <ActiveCallContext.Provider value={value}>{children}</ActiveCallContext.Provider>;
}

export function useActiveCallContext(): ActiveCallContextValue {
  return useContext(ActiveCallContext);
}
